function cloneDeep(obj) {
    var copy
    if (null == obj || 'object' != typeof obj) return obj
    // Handle Date
    if (obj instanceof Date) {
        copy = new Date()
        copy.setTime(obj.getTime())
        return copy
    }
    // Handle Array
    if (obj instanceof Array) {
        copy = []
        for (var i = 0, len = obj.length; i < len; i++) {
            copy[i] = cloneDeep(obj[i])
        }
        return copy
    }

    // Handle Function
    if (obj instanceof Function) {
        copy = function () {
            return obj.apply(this, arguments)
        }
        return copy
    }

    // Handle Object
    if (obj instanceof Object) {
        copy = {}
        for (var attr in obj) {
            if (obj.hasOwnProperty(attr)) copy[attr] = cloneDeep(obj[attr])
        }
        return copy
    }
    throw new Error("Unable to copy obj as type isn't supported ")
}

export { cloneDeep }
